// AdminNotification.type values — car-document admin notification (file icon) vs signup (user icon).
export const CAR_DOCUMENT_NOTIFICATION_TYPE = 'car_document_submitted';
export const USER_SIGNUP_NOTIFICATION_TYPE = 'user_signup';
// Car-doc review cycle: active (awaiting admin) vs cleared (approve/reject — kept for history).
export const CAR_DOCUMENT_SUBMITTED_CATEGORY = 'documents_submitted';
export const REVIEW_CLEARED_CATEGORY = 'review_cleared';

export default {
  CAR_DOCUMENT_NOTIFICATION_TYPE,
  USER_SIGNUP_NOTIFICATION_TYPE,
  CAR_DOCUMENT_SUBMITTED_CATEGORY,
  REVIEW_CLEARED_CATEGORY,
};
